import { render, staticRenderFns } from "./ShowAgreeMent.vue?vue&type=template&id=1dfe2d65&scoped=true"
import script from "./ShowAgreeMent.vue?vue&type=script&lang=js"
export * from "./ShowAgreeMent.vue?vue&type=script&lang=js"
import style0 from "./ShowAgreeMent.vue?vue&type=style&index=0&id=1dfe2d65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe2d65",
  null
  
)

export default component.exports